const prefix = 'diquex'

// Notification
export const SET_NOTIFICATION = `${prefix}/SET_NOTIFICATION`
export const CLEAN_NOTIFICATION = `${prefix}/CLEAN_NOTIFICATION`

// // i18n
// export const SET_LOCALE = `${prefix}/SET_LOCALE`

// // Transition
// export const TRANSITION_NAME = `${prefix}/TRANSITION_NAME`
// export const TRANSITION_MODE = `${prefix}/TRANSITION_MODE`

// Avatar
export const SET_PLAYER_AVATARS = `${prefix}/SET_PLAYER_AVATARS`
export const SET_PLAYER_AVATAR = `${prefix}/SET_PLAYER_AVATAR`

// Game
export const NEW_GAME = `${prefix}/NEW_GAME`
export const ADD_POINTS = `${prefix}/ADD_POINTS`
export const SUBTRACT_POINTS = `${prefix}/SUBTRACT_POINTS`
export const SET_MEDIATOR = `${prefix}/SET_MEDIATOR`
export const NEXT_PLAYER = `${prefix}/NEXT_PLAYER`
export const NEXT_MEDIATOR = `${prefix}/NEXT_MEDIATOR`
export const NEXT_TURN = `${prefix}/NEXT_TURN`
export const PREV_TURN = `${prefix}/PREV_TURN`
export const SET_TIP = `${prefix}/SET_TIP`
export const ADD_PLAYED_TIP = `${prefix}/ADD_PLAYED_TIP`
export const CLEAN_PLAYED_TIP = `${prefix}/CLEAN_PLAYED_TIP`
export const ROLLBACK_PLAYED_TIP = `${prefix}/ROLLBACK_PLAYED_TIP`
export const NEXT_CARD = `${prefix}/NEXT_CARD`
export const BEGIN_TURN = `${prefix}/BEGIN_TURN`

// Card
export const SET_CARD = `${prefix}/SET_CARD`
export const SET_CARD_LEVELS = `${prefix}/SET_CARD_LEVELS`
export const SET_CARD_TYPES = `${prefix}/SET_CARD_TYPES`
export const SET_MY_CARDS = `${prefix}/SET_MY_CARDS`
export const SET_MY_CARD = `${prefix}/SET_MY_CARD`

// User
export const LOGIN_USER = `${prefix}/LOGIN_USER`
export const LOGOUT_USER = `${prefix}/LOGOUT_USER`

// Card groups
export const SET_GAME_GROUPS = `${prefix}/SET_GAME_GROUPS`
export const UPDATE_GAME_GROUP = `${prefix}/UPDATE_GAME_GROUP`
export const REMOVE_GAME_GROUP = `${prefix}/REMOVE_GAME_GROUP`
export const REMOVE_GAME_GROUP_USER = `${prefix}/REMOVE_GAME_GROUP_USER`
export const UPDATE_GAME_GROUP_USER = `${prefix}/UPDATE_GAME_GROUP_USER`



// WEBPACK FOOTER //
// ./src/store/modules/mutation-types.js